function Contact() {
    return (
      <section style={{ background: "#f1f1f1" }}>
        <h2>Contact Us</h2>
        <p><strong>Phone:</strong> 9566554486, 7200777069</p>
        <p><strong>Email:</strong> sldpetroleumfuelenterprises@gmail.com</p>
        <p><strong>Address:</strong><br />
          W-C B-10 TS NO:5/4,<br />
          SLD PETROLEUM FUEL ENTERPRISES,<br />
          Singaravelar Salai, Karaikal Medu,<br />
          Karaikal - 609605.<br />
          <strong>GST NO:</strong> 34AFKFS1065A1ZC
        </p>
        <iframe
          src="https://www.google.com/maps?q=karaikal&output=embed"
          width="100%"
          height="300"
          style={{ border: "0", marginTop: "20px" }}
          allowFullScreen=""
          loading="lazy"
          title="Map"
        ></iframe>
      </section>
    );
  }
  export default Contact;